import { Component, createRef } from 'react';
import { BaseThemeButton } from '~/clc/features/theming/learner/components/ThemeButton';

const { I18n } = window;

class FileUploader extends Component {
  constructor(props) {
    super(props);
    this.linkRef = createRef();
    this.imgRef = createRef();
    this.imgRef = createRef();
    this.linkRef = createRef();
    this.inputRef = createRef();
  }

  componentDidMount() {
    const fileElem = $(this.inputRef.current);
    const fileSelect = $(this.linkRef.current);
    const img = $(this.imgRef.current);

    fileSelect.on('click', (e) => {
      if (fileElem) {
        fileElem.click();
      }
      e.preventDefault();
    });

    img.on('click', (e) => {
      if (fileElem) {
        fileElem.click();
      }
      e.preventDefault();
    });
  }

  handleOnPress = () => {
    const fileElem = $(this.inputRef.current);
    if (fileElem) {
      fileElem.click();
    }
  };

  render() {
    const { themeColor } = this.props;

    let link = (
      <a ref={this.linkRef} href="#">
        {this.props.title}
      </a>
    );

    if (this.props.icon) {
      link = <div ref={this.imgRef}>{this.props.icon}</div>;
    } else if (this.props.showImgLink) {
      link = themeColor ? (
        <BaseThemeButton
          variant="text-inline"
          leadingIconName="attach:regular"
          themeColor={themeColor}
          onPress={this.handleOnPress}
        >
          {this.props.title}
        </BaseThemeButton>
      ) : (
        <div className="flex">
          <img className="cursor-pointer" src="/images/attach_icon.svg" width="16px" ref={this.imgRef} />
          <a className="plm" ref={this.linkRef} href="#">
            {this.props.title}
          </a>
        </div>
      );
    }

    return (
      <div className="file-uploader-link">
        <form>
          <input
            aria-label={
              this.props.icon ? I18n.t('js.learner.file_uploader.default_attach_file_label') : this.props.title
            }
            className="file-uploader-input"
            type="file"
            ref={this.inputRef}
            onChange={this.props.handler}
            accept={this.props.accept}
          />
        </form>
        {link}
      </div>
    );
  }
}

export default FileUploader;
